// @flow
import { useDispatch } from 'react-redux';

import { deleteCart, resetCart } from '@gandi/cart';
import { notifyDanger, notifySuccess } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import styles from './ConfirmationRemoveCart.module.css';

type Props = {
  handleCancel: () => void,
};

export function ConfirmationRemoveCart({
  handleCancel,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  async function handleConfirm(): Promise<void> {
    try {
      await dispatch(deleteCart());
      await dispatch(resetCart());
      dispatch(notifySuccess(__('Cart emptied successfully.')));
    } catch (err) {
      dispatch(notifyDanger(__('Unexpected error occurred')));
    }
  }

  return (
    <div className={styles.container}>
      <p>{__('You are about to remove all items from the cart.')}</p>
      <div className={styles.containerButton}>
        <Button intent="danger" onClick={handleConfirm}>
          {__('Yes, remove')}
        </Button>
        <Button kind="outline" onClick={handleCancel}>
          {__('Cancel')}
        </Button>
      </div>
    </div>
  );
}
